<!--
 * @Author: hfxie
 * @Date: 2022-08-23 16:30:40
 * @LastEditors: hfxie
 * @LastEditTime: 2023-03-06 14:06:28
 * @Description: file content
-->
<template>
  <div class="tool-bar">

    <el-input
      clearable
      size="mini"
      class="filter-in"
      :placeholder="placeholder"
      v-model="filterStr"
      @clear="Search"
      @keydown.enter.native="Search"
      >
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>

    <!-- 展开折叠态 -->
    <!-- <i
      v-show="filterStatus"
      :data-status="filterStatus"
      class="kdfont kdfont-zhankaiquanbu filter-icon filter-icon-rank"
      @click="ChangeExpand"
    ></i>
    <i
      v-show="!filterStatus"
      :data-status="!filterStatus"
      class="kdfont kdfont-shouqiquanbu filter-icon filter-icon-rank"
      @click="ChangeExpand"
    ></i> -->

    <i
      v-show="filterStatus"
      :data-status="filterStatus"
      class="kdfont kdfont-jianshaosuojinliang filter-icon filter-icon-rank"
      @click="ChangeExpand"
    ></i>
    <i
      v-show="!filterStatus"
      :data-status="!filterStatus"
      class="kdfont kdfont-zengjiasuojinliang filter-icon filter-icon-rank"
      @click="ChangeExpand"
    ></i>
    <!-- 漏斗 -->
    <i
      class="kdfont kdfont-shaixuan filter-icon filter-icon-set"
      @click="OpenFilter"
    ></i>

  </div>
</template>

<script>
export default {
  name: "ToolBar",
  data() {
    return {
      filterStr: "",
    };
  },
  components: {

  },
  computed: {
    placeholder() {
      const placeholder = this.$store.state.data?.config?.placehold || "搜索姓名、员工号";
      return placeholder;
    },
    filterStatus() {
      const filterStatus = this.$store.state.data?.config?.filterStatus || false;
      return filterStatus;
    },
  },
  created() {
    this.filterStr = this.$store.state.local.filterStr;
  },
  methods: {
    Search() {
      this.$store.dispatch(this.$outConst.GET_FILTER, this.filterStr);
    },
    ChangeExpand() {
      const newStatus = !this.filterStatus;
      this.$store.dispatch(this.$outConst.UPDATE_FILTERSTATUS, newStatus);
    },
    OpenFilter() {
      this.$store.dispatch(this.$outConst.OPEN_SEARCH, this.filterStr);
    },
  },
};
</script>

<style scoped lang='less'>
.tool-bar{
  position: relative;
  height: 40px;
  // border-bottom: 1px solid #D9D9D9;
  .filter-in{
    width: 240px;
    height: 24px;
    margin-left: 12px;
    margin-top: 6px;
  }
  .filter-icon{
    font-size: @fs16;
    vertical-align: middle;
    position: absolute;
    top: 14px;
    cursor: pointer;
    &.filter-icon-rank{
      right: 40px;
    }
    &.filter-icon-set{
      right: 12px;

    }
  }
}
</style>
